
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Location() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="text-center text-white">
          <h1 className="text-5xl font-bold mb-4">찾아오시는길</h1>
          <p className="text-xl">올딩스 로지스 본사/센터 위치</p>
        </div>
      </section>

      {/* 주소안내와 네이버맵 좌우 배치 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              CENTER LOCATION
            </h2>
            <p className="text-xl text-gray-600">
              올딩스 본사/센터 위치
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* 좌측: 주소안내 */}
            <div className="bg-blue-50 rounded-lg p-8">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                올딩스 로지스 본사
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">주소</h4>
                    <p className="text-gray-700">청주시 청원구 내수읍 충청대로 539</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">전화번호</h4>
                    <p className="text-gray-700">010-3099-5677</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">이메일</h4>
                    <p className="text-gray-700">ydhan9@naver.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 우측: 네이버맵 */}
            <div className="flex flex-col">
              <div className="bg-white rounded-lg overflow-hidden shadow-lg h-96">
                <iframe
                  src="https://naver.me/xKtoNbNZ"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="올딩스 로지스 위치 - 네이버맵"
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 지도 앱 아이콘 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="https://naver.me/xKtoNbNZ"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-12 py-6 rounded-xl font-bold text-xl transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <i className="ri-map-line mr-3 text-2xl"></i>
              네이버맵으로 보기
            </a>
            <a
              href="https://kko.kakao.com/CUjXfPvf6F"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-12 py-6 rounded-xl font-bold text-xl transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <i className="ri-map-2-line mr-3 text-2xl"></i>
              카카오맵으로 보기
            </a>
          </div>
        </div>
      </section>

      {/* Transportation Info */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              교통 안내
            </h2>
            <p className="text-xl text-gray-600">
              다양한 교통수단으로 편리하게 방문하세요
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-car-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">자가용</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 경부고속도로 청주IC 이용</li>
                <li>• 청주IC에서 약 15분 소요</li>
                <li>• 충청대로 직진</li>
                <li>• 무료 주차장 완비</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-bus-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">대중교통</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 청주터미널에서 시내버스 이용</li>
                <li>• 내수읍 방면 버스 탑승</li>
                <li>• 충청대로 정류장 하차</li>
                <li>• 도보 5분 거리</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-train-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">KTX/기차</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 오송역 KTX 이용</li>
                <li>• 오송역에서 택시 약 20분</li>
                <li>• 청주역에서 시내버스 연결</li>
                <li>• 사전 연락시 픽업 가능</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
